// 2024-01-26 - this is the replacement for the SearchFilterMixin
import { pathOr } from "ramda";

export default function useSearchFilter() {
  const filterDataBySearchTerm = (searchTerm, propsListToSearch, data) => {
    if (!searchTerm) {
      return data;
    }

    let result = data.filter((row) => {
      let isIncluded = false;
      for (let key of propsListToSearch) {
        let rowValue = pathOr("", key.split("."), row).toString();
        if (
          rowValue.includes &&
          rowValue.toLowerCase().includes(searchTerm.toLowerCase())
        ) {
          isIncluded = true;
        }
      }
      return isIncluded;
    });
    return result;
  };
  return {
    filterDataBySearchTerm,
  };
}
